import { Brand } from '../../../../embedding/dwt-app';
import { FiatRichTextStyle } from '../fiat/fiat-rich-text-style';
import { DsRichTextStyle } from '../ds/ds-rich-text-style';
import { CitRichTextStyle } from '../citroen/cit-rich-text-style';
import { AlfaRichTextStyle } from '../alfa/alfa-rich-text-style';
import { AbarthRichTextStyle } from '../abarth/abarth-rich-text-style';
import { IsuRichTextStyle } from '../isuzu/isu-rich-text-style';
import { JeepRichTextStyle } from '../jeep/jeep-rich-text-style';
import { LanciaRichTextStyle } from '../lancia/lancia-rich-text-style';
import { OpelRichTextStyle } from '../opel/opel-rich-text-style';
import { OpelNewRichTextStyle } from '../opelnew/opelnew-rich-text-style';
import { PeuRichTextStyle } from '../peugeot/peu-rich-text-style';
import { SsgRichTextStyle } from '../ssangyong/ssg-rich-text-style';
export const getRichTextStyleByBrand = (brand: Brand) => {
  switch (brand) {
    case 'fiat':
      return FiatRichTextStyle;
    case 'ds':
      return DsRichTextStyle;
    case 'alfaromeo':
      return AlfaRichTextStyle;
    case 'jeep':
      return JeepRichTextStyle;
    case 'isuzu':
      return IsuRichTextStyle;
    case 'abarth':
      return AbarthRichTextStyle;
    case 'ssangyong':
      return SsgRichTextStyle;
    case 'peugeot':
      return PeuRichTextStyle;
    case 'citroen':
      return CitRichTextStyle;
    case 'opel':
      return OpelRichTextStyle;
    case 'opelold':
      return OpelNewRichTextStyle;
    case 'lancia':
      return LanciaRichTextStyle;
    default:
      return OpelNewRichTextStyle;
  }
};

const ALLOWED_BRANDS = ['FIAT', 'JEEP', 'ABARTH', 'ALFAROMEO', 'ISUZU', 'SSANGYONG', 'LANCIA', 'DS', 'CITROEN'];

export const allowEmptyPTags = (brand: string): boolean => {
  return ALLOWED_BRANDS.includes(brand?.toUpperCase());
};
